import $ from "cash-dom";

$(function () {
	const UiFixes = {
		init() {
			this._initBackgroundHeaderWithImagesHeights();
		},

		_initBackgroundHeaderWithImagesHeights() {
			if (!$('#header-background-2, #header-background').length) {
				return;
			}

			const $siteHeader = $('#site-header');
			const $ppcHeader = $('.ppc-header');

			const calculateAndSetHeights = () => {
				const backgroundHeaderWithImagesHeight = $siteHeader.outerHeight(true) + $ppcHeader.outerHeight(true);
				document.documentElement.style.setProperty('--background-header-with-image-height', backgroundHeaderWithImagesHeight + "px");
			};

			$(window).on('resize', () => {
				calculateAndSetHeights();
			});

			calculateAndSetHeights();
		},
	};

	UiFixes.init();
});
